// @flow

import Vue from 'vue'
import Vuex from 'vuex'
import get from 'lodash/get'

import type { ChatBubbleMessage, DeviceType } from '@chatchamp/chatchamp-types'

import { isRequestInputMessage } from '../models'

import bubble from './modules/bubble'
import welcomeMessage from './modules/welcomeMessage'
import messages from './modules/messages'
import openChat from './modules/openChat'
import notification from './modules/notification'

import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { createState } from './state'

Vue.use(Vuex)

function getLatestNonTypingOffMessage (newMessages): ?ChatBubbleMessage<any> {
  for (let i = newMessages.length - 1; i >= 0; --i) {
    const message = newMessages[i]
    if (get(message, ['content', 'senderAction'], '') !== 'typing_off') return message
  }
}

export function createStore (customerId: string, subscriberId: string, parentUrl: string, device: DeviceType): any {
  const store = new Vuex.Store({
    modules: {
      bubble,
      welcomeMessage,
      messages,
      openChat,
      notification
    },
    state: createState(customerId, subscriberId, parentUrl, device),
    getters,
    mutations,
    actions
  })

  store.watch((state) => state.messages.messages, (newMessages) => {
    const latestValidMessage = getLatestNonTypingOffMessage(newMessages)
    if (latestValidMessage && isRequestInputMessage(latestValidMessage)) {
      store.commit('setIsTypingEnabled', true)
    } else {
      store.commit('setIsTypingEnabled', false)
    }
  })

  return store
}
